import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  base: process.env.VUE_APP_BASE_URL,
  linkExactActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/home',
      name: 'home',
      props: true,
      meta: {
        layout: 'page'
      },
      component: () => import('./pages/HomePage')
    },
    {
      path: '/tools',
      name: 'hsm-tools',
      meta: {
        layout: 'page'
      },
      component: () => import('./pages/HsmPages/HsmTools/HsmToolsPage.vue')
    },
    {
      path: '/new-secret',
      name: 'new-secret',
      meta: {
        layout: 'page'
      },
      component: () => import('./pages/HsmPages/HsmTools/SafeKeeping/NewSecret.vue')
    },
    {
      path: '/split-secret',
      name: 'split-secret',
      meta: {
        layout: 'page'
      },
      component: () => import('./pages/HsmPages/HsmTools/SafeKeeping/SplitSecret.vue')
    },
    {
      path: '/match-recover-secret',
      name: 'match-recover-secret',
      meta: {
        layout: 'page'
      },
      component: () => import('./pages/HsmPages/HsmTools/SafeKeeping/MatchRecoverSecret.vue')
    },
    {
      path: '/settings',
      name: 'hsm-settings',
      meta: {
        layout: 'page'
      },
      component: () => import('./pages/HsmPages/HsmSettingsPage/HsmSettingsPage')
    },
    {
      path: '/about',
      name: 'about',
      meta: {
        layout: 'page'
      },
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/AboutPage')
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        layout: 'auth',
        public: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ './pages/AuthPages/LoginPage')
    },
    {
      path: '/renew-password',
      name: 'renewPassword',
      meta: {
        layout: 'auth',
        public: true
      },
      component: () =>
        import(/* webpackChunkName: "renew-password" */ './pages/AuthPages/RenewPasswordPage')
    },
    {
      path: '/new-key',
      name: 'new-key',
      props: true,
      meta: {
        layout: 'page'
      },
      component: () =>
        import(/* webpackChunkName: "import-keys" */ './pages/PartitionPages/PartitionObjectsPage/modals/KeysNewModal')
    },
    {
      path: '/import',
      name: 'import-keys',
      meta: {
        layout: 'page'
      },
      component: () =>
        import(/* webpackChunkName: "import-keys" */ './pages/PartitionPages/PartitionObjectsPage/modals/ImportModal/ImportModal')
    },
    {
      path: '/export',
      name: 'export-keys',
      props: true,
      meta: {
        layout: 'page'
      },
      component: () =>
        import(/* webpackChunkName: "import-keys" */ './pages/PartitionPages/PartitionObjectsPage/modals/ExportObjects/KeysExportModal.vue')
    },
    {
      path: '/csr-p10',
      name: 'csr',
      props: true,
      meta: {
        layout: 'page'
      },
      component: () =>
        import(/* webpackChunkName: "import-keys" */ './components/forms/CsrP10Modal')
    },

    {
      path: '/edit-key',
      name: 'edit-key',
      props: true,
      meta: {
        layout: 'page'
      },
      component: () =>
        import(/* webpackChunkName: "import-keys" */ './pages/PartitionPages/PartitionObjectsPage/modals/KeysEditModal/KeysEditModal')
    },
    {
      path: '/get-addr',
      name: 'get-addr',
      props: true,
      meta: {
        layout: 'page'
      },
      component: () =>
        import('./pages/PartitionPages/PartitionObjectsPage/modals/GetAddr.vue')
    },
    {
      path: '/derive',
      name: 'derive',
      props: true,
      meta: {
        layout: 'page'
      },
      component: () =>
        import('./pages/PartitionPages/PartitionObjectsPage/modals/DeriveKey.vue')
    },
    {
      path: '/get-pbk',
      name: 'get-pbk',
      props: true,
      meta: {
        layout: 'page'
      },
      component: () =>
        import('./pages/PartitionPages/PartitionObjectsPage/modals/ExportObjects/KeysExportModal.vue')
    },
    {
      path: '/edit-permission',
      name: 'edit-permission',
      props: true,
      meta: {
        layout: 'page'
      },
      component: () =>
        import(/* webpackChunkName: "import-keys" */ './pages/PartitionPages/PartitionPermissionsPage/modals/PermissionsNewModal.vue')
    },
    {
      path: '/partition',
      name: 'partition',
      component: () =>
        import(/* webpackChunkName: "partition" */ './pages/PartitionPages/PartitionPage'),
      children: [
        {
          path: 'keys',
          name: 'partition-keys',
          meta: {
            layout: 'page'
          },
          component: () =>
            import(/* webpackChunkName: "partition-keys" */ './pages/PartitionPages/PartitionObjectsPage')
        },
        {
          path: 'permissions',
          name: 'partition-permissions',
          meta: {
            layout: 'page'
          },
          component: () =>
            import(/* webpackChunkName: "partition-permissions" */ './pages/PartitionPages/PartitionPermissionsPage')
        }
      ]
    },
    {
      path: '/edit-user',
      name: 'edit-user',
      props: true,
      meta: {
        layout: 'page'
      },
      component: () =>
        import(/* webpackChunkName: "import-keys" */ './pages/UsersPages/modals/UsersNewModal/UsersNewModal.vue')
    },
    {
      path: '/users',
      name: 'users',
      component: () =>
        import(/* webpackChunkName: "users" */ './pages/UsersPages/UsersPage'),
      children: [
        {
          path: 'management',
          name: 'users-management',
          meta: {
            layout: 'page',
            perm: 'canListUser'
          },
          component: () =>
            import(/* webpackChunkName: "users-management" */ './pages/UsersPages/UsersManagementPage')
        },
        {
          path: 'password-policy',
          name: 'users-password-policy',
          meta: {
            layout: 'page',
            perm: 'canUserAccessRemoteLog'
          },
          component: () =>
            import(/* webpackChunkName: "users-password-policy" */ './pages/UsersPages/UsersPasswordPolicyPage')
        }
      ]
    },
    {
      path: '/hsm',
      name: 'hsm',
      component: () =>
        import(/* webpackChunkName: "hsm" */ './pages/HsmPages/HsmPage'),
      children: [
        {
          path: 'info',
          name: 'hsm-info',
          meta: {
            layout: 'page',
            perm: 'canUserAccessRemoteLog'
          },
          component: () =>
            import(/* webpackChunkName: "hsm-info" */ './pages/HsmPages/HsmInfoPage')
        },
        {
          path: 'log',
          name: 'hsm-log',
          meta: {
            layout: 'page',
            perm: 'canUserAccessRemoteLog'
          },
          component: () =>
            import(/* webpackChunkName: "hsm-log" */ './pages/HsmPages/HsmLogPage')
        },
        {
          path: 'backup',
          name: 'hsm-backup',
          meta: {
            layout: 'page',
            perm: 'canUserExtractBackup'
          },
          component: () =>
            import(/* webpackChunkName: "hsm-backup" */ './pages/HsmPages/HsmBackupPage/HsmBackupPage')
        },
        {
          path: 'replication',
          name: 'hsm-replication',
          meta: {
            layout: 'page',
            perm: 'canUserAccessRemoteLog'
          },
          component: () =>
            import(/* webpackChunkName: "hsm-replication" */ './pages/HsmPages/HsmReplicationPage')
        }
      ]
    },
    {
      path: '/popup',
      name: 'popup',
      component: () =>
        import(/* webpackChunkName: "monitor" */ './pages/PopupPages/PopupPage'),
      children: [
        {
          path: 'cpu',
          name: 'monitor-cpu-popup',
          meta: {
            layout: 'popup',
            perm: 'canUserAccessRemoteLog'
          },
          component: () =>
            import(/* webpackChunkName: "monitor-cpu-popup" */ './pages/PopupPages/MonitorCpuPopupPage')
        },
        {
          path: 'sessions',
          name: 'monitor-sessions-popup',
          meta: {
            layout: 'popup',
            perm: 'canUserAccessRemoteLog'
          },
          component: () =>
            import(/* webpackChunkName: "monitor-sessions-popup" */ './pages/PopupPages/MonitorSessionsPopupPage')
        },
        {
          path: 'events',
          name: 'monitor-events-popup',
          meta: {
            layout: 'popup',
            perm: 'canUserAccessRemoteLog'
          },
          component: () =>
            import(/* webpackChunkName: "monitor-events-popup" */ './pages/PopupPages/MonitorEventsPopupPage')
        }
      ]
    },
    {
      path: '/profile',
      name: 'profile',
      meta: {
        layout: 'page'
      },
      component: () =>
        import(/* webpackChunkName: "profile" */ './pages/ProfilePages/ProfilePage')
    },
    {
      path: '/not-authorized',
      name: 'not-authorized',
      meta: {
        layout: 'page'
      },
      component: () =>
        import(/* webpackChunkName: "not-authorized" */ './pages/NotAuthorizedPage')
    },
    {
      path: '/not-found',
      name: 'not-found',
      meta: {
        layout: 'page'
      },
      component: () =>
        import(/* webpackChunkName: "not-found" */ './pages/NotFoundPage')
    },
    {
      path: '*',
      beforeEnter: (to, from, next) => {
        next({ name: 'not-found' })
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const isLogged = store.state.auth.isLogged

  store.commit('ui/SET_LOADING', true)
  store.commit('ui/SET_LAYOUT', to.meta.layout)

  if (to.matched.some(record => record.meta.public)) {
    return next()
  } else {
    if (!isLogged) {
      store.commit('ui/SET_LAYOUT', from.meta.layout)
      store.commit('ui/SET_LOADING', false)
      return next({ name: 'login' })
    } else {
      store.dispatch('auth/doSetAcl').then(() => {
        const userPerms = store.getters['auth/getPermissions']

        if (to.meta.perm) {
          if (userPerms[to.meta.perm] === true) {
            userPerms.canUserAccessRemoteLog && store.dispatch('warning/load')
            return next()
          } else {
            store.commit('ui/SET_LOADING', false)
            return next({ name: 'not-authorized' })
          }
        } else {
          return next(from.query.to)
        }
      })

      return next()
    }
  }
})

router.afterEach(() => {
  store.commit('ui/SET_LOADING', false)
})

export default router
